import { useEffect, useState } from "react";
import { useGetCoursesBySchoolByQueryQuery } from "../../../graphql/generated/graphql";
import SearchListModal from "../../../components/common/SearchListModal/SearchListModal";
import { UsersTabModalState } from "./UsersTabContainer";
import { useAppConfig } from "../../../AppConfigProvider";

const AssignCourseToFacultyListContainer = ({
  visible,
  onClose,
  onAction,
}: {
  visible: boolean;
  onClose: () => void;
  onAction: (id: string) => void;
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const appConfig = useAppConfig();
  const schoolId = appConfig.axioSchools[0];

  const { data: coursesData, refetch: coursesRefetch } = useGetCoursesBySchoolByQueryQuery({
    variables: {
      schoolId,
      searchQuery,
      page: 1,
      pageSize: 5,
    },
  });

  useEffect(() => {
    coursesRefetch();
  }, [searchQuery]);

  const list =
    coursesData?.getCoursesBySchoolByQuery?.data.courses.map((course) => {
      return {
        id: course.id,
        name: course.name,
      };
    }) || [];

  return (
    <SearchListModal<UsersTabModalState>
      visible={visible}
      onClose={onClose}
      onAction={onAction}
      list={list}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      modalType={UsersTabModalState.ASSIGN_COURSE}
      title={"Assign Course"}
    />
  );
};

export default AssignCourseToFacultyListContainer;
